// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-support-container {
  position: fixed;
  bottom: 100px; /* Increased from 25px to accommodate sticky bars */
  left: 25px;
  z-index: 2000000;
  /* Above everything */
  cursor: pointer;
  opacity: 0;
  transform: translateY(20px) scale(0.8);
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  touch-action: none;
}

.floating-support-container.visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.floating-support-button {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.4);
  color: white;
  position: relative;
  transition: all 0.3s ease;
}

.floating-support-container:hover .floating-support-button {
  transform: scale(1.05) rotate(5deg);
}

.floating-support-container.active .floating-support-button {
  background: #f1f5f9;
  color: #1e293b;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.support-icon {
  font-size: 20px;
}

.support-icon-ai {
  font-size: 24px;
  filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  animation: ai-float 3s ease-in-out infinite;
  margin-top: 2px;
}

@keyframes ai-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}

.support-tooltip {
  position: absolute;
  left: 65px;
  background: #1e293b;
  color: white;
  padding: 8px 15px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
  pointer-events: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.floating-support-container:hover .support-tooltip {
  opacity: 1;
  transform: translateX(0);
}

.support-tooltip::after {
  content: '';
  position: absolute;
  left: -6px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 6px 6px 6px 0;
  border-style: solid;
  border-color: transparent #1e293b transparent transparent;
}

.floating-support-pulse {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #2563eb;
  border-radius: 50%;
  opacity: 0.6;
  z-index: -1;
  animation: support-pulse 2s infinite;
}

.floating-support-container.active .floating-support-pulse {
  display: none;
}

@keyframes support-pulse {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }

  100% {
    transform: scale(2);
    opacity: 0;
  }
}

/* Chat Modal Styles */
.chat-modal-overlay {
  position: fixed;
  bottom: 85px;
  left: 25px;
  width: 370px;
  height: 450px;
  max-height: calc(100vh - 110px);
  z-index: 1000000;
  visibility: hidden;
  opacity: 0;
  transform: translateY(20px) scale(0.95);
  transform-origin: bottom left;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.chat-modal-overlay.show {
  visibility: visible;
  opacity: 1;
  transform: translateY(0) scale(1);
}

.chat-modal-wrapper {
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.chat-modal-header {
  height: 50px;
  padding: 0 15px;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-header-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
}

.chat-status-dot {
  width: 8px;
  height: 8px;
  background: #22c55e;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);
}

.chat-close-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
}

.chat-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.chat-iframe-container {
  flex: 1 1;
  position: relative;
  background: #f8fafc;
}

.chat-iframe-container iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border: none;
}

/* Mobile Adjustments */
@media (max-width: 480px) {
  .floating-support-container {
    bottom: 120px;
    left: 15px;
    z-index: 2147483647;
  }

  .chat-modal-overlay {
    bottom: 0px;
    right: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    max-height: 100vh;
    border-radius: 0;
    transform: translateY(100%);
    z-index: 2147483646;
  }

  .chat-modal-overlay.show {
    transform: translateY(0);
  }

  .chat-modal-wrapper {
    border-radius: 0;
    height: 100%;
  }

  /* Show the header on mobile so user can close the chat */
  .chat-modal-header {
    display: flex;
    height: 56px;
    padding: 0 16px;
    background: linear-gradient(135deg, #1e40af 0%, #1e293b 100%);
  }

  .chat-header-info {
    font-size: 15px;
  }

  /* Large, easy-to-tap close button on mobile */
  .chat-close-btn {
    display: flex;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
    font-size: 17px;
    align-items: center;
    justify-content: center;
  }

  .chat-close-btn:active {
    background: rgba(255, 255, 255, 0.35);
    transform: scale(0.92);
  }

  .support-tooltip {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FloatingSupport.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa,EAAE,mDAAmD;EAClE,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,sCAAsC;EACtC,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qDAAqD;EACrD,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,uCAAuC;EACvC,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA,yDAAyD;EACzD;IACE,aAAa;IACb,YAAY;IACZ,eAAe;IACf,6DAA6D;EAC/D;;EAEA;IACE,eAAe;EACjB;;EAEA,8CAA8C;EAC9C;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".floating-support-container {\n  position: fixed;\n  bottom: 100px; /* Increased from 25px to accommodate sticky bars */\n  left: 25px;\n  z-index: 2000000;\n  /* Above everything */\n  cursor: pointer;\n  opacity: 0;\n  transform: translateY(20px) scale(0.8);\n  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  touch-action: none;\n}\n\n.floating-support-container.visible {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n}\n\n.floating-support-button {\n  width: 50px;\n  height: 50px;\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.4);\n  color: white;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.floating-support-container:hover .floating-support-button {\n  transform: scale(1.05) rotate(5deg);\n}\n\n.floating-support-container.active .floating-support-button {\n  background: #f1f5f9;\n  color: #1e293b;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.support-icon {\n  font-size: 20px;\n}\n\n.support-icon-ai {\n  font-size: 24px;\n  filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));\n  animation: ai-float 3s ease-in-out infinite;\n  margin-top: 2px;\n}\n\n@keyframes ai-float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-3px); }\n}\n\n.support-tooltip {\n  position: absolute;\n  left: 65px;\n  background: #1e293b;\n  color: white;\n  padding: 8px 15px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  opacity: 0;\n  transform: translateX(-10px);\n  transition: all 0.3s ease;\n  pointer-events: none;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.floating-support-container:hover .support-tooltip {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.support-tooltip::after {\n  content: '';\n  position: absolute;\n  left: -6px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-width: 6px 6px 6px 0;\n  border-style: solid;\n  border-color: transparent #1e293b transparent transparent;\n}\n\n.floating-support-pulse {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #2563eb;\n  border-radius: 50%;\n  opacity: 0.6;\n  z-index: -1;\n  animation: support-pulse 2s infinite;\n}\n\n.floating-support-container.active .floating-support-pulse {\n  display: none;\n}\n\n@keyframes support-pulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.6;\n  }\n\n  100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n\n/* Chat Modal Styles */\n.chat-modal-overlay {\n  position: fixed;\n  bottom: 85px;\n  left: 25px;\n  width: 370px;\n  height: 450px;\n  max-height: calc(100vh - 110px);\n  z-index: 1000000;\n  visibility: hidden;\n  opacity: 0;\n  transform: translateY(20px) scale(0.95);\n  transform-origin: bottom left;\n  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.chat-modal-overlay.show {\n  visibility: visible;\n  opacity: 1;\n  transform: translateY(0) scale(1);\n}\n\n.chat-modal-wrapper {\n  width: 100%;\n  height: 100%;\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.chat-modal-header {\n  height: 50px;\n  padding: 0 15px;\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.chat-header-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.chat-status-dot {\n  width: 8px;\n  height: 8px;\n  background: #22c55e;\n  border-radius: 50%;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);\n}\n\n.chat-close-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: white;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.chat-close-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.chat-iframe-container {\n  flex: 1;\n  position: relative;\n  background: #f8fafc;\n}\n\n.chat-iframe-container iframe {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border: none;\n}\n\n/* Mobile Adjustments */\n@media (max-width: 480px) {\n  .floating-support-container {\n    bottom: 120px;\n    left: 15px;\n    z-index: 2147483647;\n  }\n\n  .chat-modal-overlay {\n    bottom: 0px;\n    right: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n    transform: translateY(100%);\n    z-index: 2147483646;\n  }\n\n  .chat-modal-overlay.show {\n    transform: translateY(0);\n  }\n\n  .chat-modal-wrapper {\n    border-radius: 0;\n    height: 100%;\n  }\n\n  /* Show the header on mobile so user can close the chat */\n  .chat-modal-header {\n    display: flex;\n    height: 56px;\n    padding: 0 16px;\n    background: linear-gradient(135deg, #1e40af 0%, #1e293b 100%);\n  }\n\n  .chat-header-info {\n    font-size: 15px;\n  }\n\n  /* Large, easy-to-tap close button on mobile */\n  .chat-close-btn {\n    display: flex;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.18);\n    font-size: 17px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .chat-close-btn:active {\n    background: rgba(255, 255, 255, 0.35);\n    transform: scale(0.92);\n  }\n\n  .support-tooltip {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
